import React from 'react';
import { CssBaseline } from '@mui/material';
import { StyledEngineProvider, createTheme, ThemeProvider } from '@mui/material/styles';

import lightPalette from './paletteLight';
import darkPalette from './paletteDark';
import typography from './typography';

interface ThemeConfigProps {
  children: React.ReactNode;
}

const ThemeConfig = ({ children }: ThemeConfigProps) => {
  const theme = createTheme({
    cssVariables: { colorSchemeSelector: 'class' },
    colorSchemes: {
      light: { palette: lightPalette },
      dark: { palette: darkPalette },
    },
    shape: { borderRadius: 8 },
    typography,
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          // Exposed for the :focus-visible rule in fonts.css.
          ':root': { '--mcw-focus': '#f3eee7' },
        },
      },
    },
  });

  return (
    <StyledEngineProvider injectFirst>
      {/* The mockups specify a single dark treatment; light is not offered yet. */}
      <ThemeProvider theme={theme} defaultMode="dark">
        <CssBaseline />
        {children}
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default ThemeConfig;
